// @flow

import type { Rules } from 'frame/core/formValidate'

import { dispatch, getState } from 'redux/store'
import { setMap, mergeMap } from 'redux/action'

import { Map } from 'immutable'
import { getPageInfo } from '../pageInfo'

function getCode () {
  return getPageInfo().code
}

// 是否在易发编辑器环境
export function isInEditor (): boolean {
  return getState().map.get('easyEditor') != null
}

// rootData
function getRootDataPath (namespace?: ?string): Array<string | number> {
  let namespaceArray: Array<string> = []
  if (namespace) {
    namespaceArray = namespace.split('.')
  }
  return ['easyPublicBasic', getCode(), 'rootData', ...namespaceArray]
}

export function setRootData (namespace: ?string, value: any) {
  const path = getRootDataPath(namespace)
  dispatch(setMap(path, value))
}

export function getRootData (): any {
  return getState().map.getIn(getRootDataPath())
}

// form
export function setFormValues (formId: string, values: {}) {
  const path = ['easyPublicBasic', getCode(), 'forms', formId]
  dispatch(mergeMap(path, Map(values)))
}

export function coverFormValues (formId: string, values: {}) {
  const path = ['easyPublicBasic', getCode(), 'forms', formId]
  dispatch(setMap(path, Map(values)))
}

export function getFormValues (formId: string): any {
  const path = ['easyPublicBasic', getCode(), 'forms', formId]
  return getState().map.getIn(path)
}

export function setFormValidateRules (
  formId: string,
  fieldId: string,
  fieldRoles: { [fieldName: string]: Rules }
) {
  const path = ['easyPublicBasic', getCode(), 'formValidates', formId, fieldId]
  dispatch(setMap(path, Map(fieldRoles)))
}

export function getFormValidateRules (formId: string) {
  const path = ['easyPublicBasic', getCode(), 'formValidates', formId]
  const rulesMap = getState().map.getIn(path)
  let rules = {}
  if (rulesMap) {
    let tempRules = rulesMap.toJS()
    for (let key in tempRules) {
      rules = { ...rules, ...tempRules[key] }
    }
  }
  return rules
}

export function setVisitor (visitor: any) {
  dispatch(setMap(['easyPublicBasic', 'visitor'], visitor))
}

export function getVisitor () {
  return getState().map.getIn(['easyPublicBasic', 'visitor'])
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/redux/basic.js